import { Component, ViewChild,  TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Constructores } from '../../../models/constructores.model';
import { MatDialog } from '@angular/material';
import {  Validators, FormBuilder } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { FormService } from 'src/app/services/form.service';
import { NgxSpinnerService } from 'ngx-spinner';

declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-empresa-profesional",
    templateUrl: "./empresa_profesional.component.html",
    styleUrls: ["./empresa_profesional.component.css"],
    providers: [UserService, FormService]
})

export class EmpresaProfesionalComponent {

    @ViewChild('openModal') openModal:TemplateRef<any>;
    @ViewChild('openModalNODATA') openModalNODATA: TemplateRef<any>;

    public rut_const;
    public invalidRut: Boolean;
    public constructores: Constructores;
    public rows = [];
    public actualRow;
    public matcher = new FormService();
    public selectedCons:number = null;



    constructor(private fb: FormBuilder, private _userService: UserService,
        private rutValidator: RutValidator, private dialog: MatDialog, private spinner: NgxSpinnerService){
            this.rut_const = this.fb.group({
                rut: ['', [Validators.required, this.rutValidator]]})

        if(!JSON.parse(localStorage.getItem("constructores"))){
            localStorage.setItem("constructores", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("constructores"));
        }
            this.invalidRut = true;
            this.constructores = {rut: '',nombre:'', mail:'',apellido_mat:'',apellido_pat:'',
            direccion: '',direccion_complemento:'',direccion_num:'',comuna:'',fono:'', fax:'', patente:'', recordId:''};
    }

    get_Constructores(rut){
        this.spinner.show();
        this._userService.getConstructores(rut).subscribe(
            response => {
                if(response.message){
                    this.constructores.rut = rut ? rut : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModal);
                } else {
                    this.constructores.rut = response.rut ? response.rut : '';
                    this.constructores.nombre = response.nombre ? response.nombre : '';
                    this.constructores.mail = response.mail ? response.mail : '';
                    this.constructores.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
                    this.constructores.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
                    this.constructores.direccion = response.direccion ? response.direccion : '';
                    this.constructores.direccion_num = response.direccion_num ? response.direccion_num : '';
                    this.constructores.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                    this.constructores.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                    this.constructores.comuna = response.comuna ? response.comuna : '';
                    this.constructores.fono = response.fono ? response.fono : '';
                    this.constructores.fax = response.fax ? response.fax : '';
                    this.constructores.patente = response.patente ? response.patente : '';
                    this.constructores.recordId = response.recordId ? response.recordId : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModal);
                }

            },
            error => {
                console.log(error)
                this.spinner.hide();
            }
        )
    }



    cleanData(){
        this.constructores = {rut: '',nombre:'',apellido_mat:'',apellido_pat:'', direccion: '',direccion_complemento:'',direccion_completa:'',direccion_num:'',comuna:'',fono:'', fax:'', mail:'', patente:'', recordId:''};
            this.rut_const.reset()
    }

    update_Constructores(rut, id) {
        this.get_Constructores(rut);
        this.selectedCons = id;
    }


    saveConstructores() {
        window.scroll(0,0);
        //elimina la fila si escriben un rut que ya esté ingresado
        for (let x = 0; x < this.rows.length; x++) {           
            if (this.constructores.rut == this.rows[x].rut) {                
                this.delete_Constructores(x);
            }
        }
        
        //elimina fila cuando la editan
        /*if (this.selectedCons != null) {
            this.delete_Constructores(this.selectedCons);
            this.selectedCons = null;
        }*/

        this.spinner.show();
        this._userService.saveConstructores(this.constructores).subscribe(
            response => {
                this.spinner.hide();

                console.log(response)
                if(response.update || response.save){
                    $("#const_modal").modal("hide");
                    this.actualRow = localStorage.getItem("constructores");
                    this.rows = JSON.parse(this.actualRow);
                    this.rows = this.rows.concat({
                        rut: this.constructores.rut,
                        nombre: this.constructores.nombre,
                        apellido_mat: this.constructores.apellido_mat,
                        apellido_pat: this.constructores.apellido_pat,
                        direccion:this.constructores.direccion, 
                        direccion_num:this.constructores.direccion_num, 
                        direccion_complemento:this.constructores.direccion_complemento, 
                        direccion_completa:this.constructores.direccion_completa, 
                        comuna:this.constructores.comuna, 
                        fono:this.constructores.fono,
                        fax:this.constructores.fax,
                        mail:this.constructores.mail,
                        patente:this.constructores.patente
                
                    })
                    localStorage.setItem("constructores", JSON.stringify(this.rows));
                    this.constructores = {rut: '',nombre:'',apellido_mat:'',apellido_pat:'', direccion: '',direccion_complemento:'',direccion_completa:'',direccion_num:'',comuna:'',fono:'', fax:'', mail:'', patente:'', recordId:''};
                    this.rut_const.reset()
                    this.dialog.closeAll();
                }
            },
            error => {
                this.spinner.hide();

                console.log(error)
            }
        )
    }
    delete_Constructores(id){
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("constructores", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem('constructores'));
            }
        }
    }
}